export const xdcRegex = '^0x[a-fA-F0-9]{40}$|^xdc[a-fA-F0-9]{40}$';
